// import { useColumnHistoryService } from './useColumnHistoryService'
import { useColumnService } from './useColumnService'
import { SearchOutlined } from '@ant-design/icons'
import { Divider, Empty, Menu, MenuProps, Select, Table } from 'antd'
import { EStatus } from 'enums'
import { useFormatData, useService } from 'hooks'
import { t } from 'i18next'
import { IGroupService } from 'pages/menuGroupService/interfaces'
import { ISubService } from 'pages/menuSubServices/interfaces'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useExamService } from 'services'
import styled from 'styled-components'
import { StyleCardTitle2 } from 'styles/styledGlobal'

const StyleContainerTab = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  .ant-menu-submenu-title:hover {
    .ant-menu-title-content {
      color: var(--color-primary-primary) !important;
      opacity: 0.85;
    }
    .ant-menu-submenu-arrow {
      color: var(--color-primary-primary) !important;
    }
  }
`

const StyleLeftContent = styled.div`
  .ant-menu.ant-menu-root {
    border-right: none;
    max-height: 300px;
    overflow: auto;
    overflow-x: hidden;
  }
  .ant-menu-submenu {
    border-bottom: 1px solid var(--color-gray-103);
  }
  .ant-menu-submenu-title {
    padding: 0 8px !important;
    color: var(--color-gray-110);
    font-weight: 600;
  }
  .ant-menu-item {
    color: var(--color-gray-110);
    padding: 0 16px !important;
  }
  .ant-menu-submenu-arrow {
    color: var(--color-gray-110);
  }
  .ant-menu-item-selected,
  .ant-menu-item-active {
    background-color: white !important;
    color: var(--color-gray-110) !important;
    &:hover {
      background-color: white !important;
      color: var(--color-gray-110) !important;
    }
  }
  .ant-menu-title-content {
    line-height: 22px;
  }
  .ant-menu-item:hover {
    color: var(--color-gray-110) !important;
  }
  .ant-menu-item-only-child:hover {
    background-color: var(--color-gray-103) !important;
    border-radius: 4px;
  }
`

export const StyleRightContent = styled.div<{ $hasBoxShadow?: boolean }>`
  flex: 1;
  ${({ $hasBoxShadow }) =>
    $hasBoxShadow ? 'box-shadow: 0px 1px 30px rgba(85, 85, 85, 0.1);' : ''}
  .ant-select {
    width: 300px;
  }
  .ant-table-body {
    max-height: 300px;
  }
`

export const StyleListMenu = styled.div``

const StyleSelect = styled(Select)`
  width: 100%;
  input {
    padding: 0 12px !important;
  }
  svg {
    width: 18px;
    height: 18px;
  }
`

export const StyleItem = styled.div`
  padding: 10px 8px 10px 16px;
  background-color: #fff;
  color: #25282b;
  border-bottom: 1px solid #ececec;
  cursor: pointer;

  &.active {
    background-color: #f5fbf9;
  }
`

const StyleBodyContent = styled.div`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  margin: 16px 0;
`

export const StyleFooterContent = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
`
export const StyledSpanCurrency = styled.span`
  margin-left: 0px;
`

export const StyleHeadingWithButton = styled.div`
  display: flex;
  justify-content: space-between;
`

export const StyleInforService = styled.div`
  font-weight: 800;
  color: var(--color-primary-108);
  padding: 0 12px;
  position: relative;
  min-width: 200px;

  &:after {
    content: '';
    display: inline-block;
    width: 1px;
    height: 20px;
    background-color: var(--color-primary-primary);
    right: 0;
    position: absolute;
  }

  &:last-child {
    &:after {
      display: none;
    }
  }
`

export const StyleTotal = styled(StyleInforService)`
  text-align: right;
`
export const StyledAsterisk = styled.a`
  color: red;
  margin-left: 4px;
`
const StyledTable = styled(Table)<{ $preventSelect?: boolean }>`
  ${({ $preventSelect }) => {
    if ($preventSelect) {
      return `
        img {
          opacity: 0.3;
          filter: brightness(4) invert(1);
          cursor: not-allowed;
          &:hover {
            opacity: 0.3;
            filter: brightness(4) invert(1);
          }
        }
      `
    }
  }}
`
type MenuItem = Required<MenuProps>['items'][number]

export interface ISubServicesSelected {
  price?: number
  subServiceIds?: Array<number>
}

export const getSubServiceFromServices = (services: Array<IGroupService>) => {
  let subServices: Array<ISubService> = []
  if (services) {
    services?.forEach((s) => {
      const newSs =
        s?.sub_services?.map((ss) => {
          return { ...ss, major_name: s?.major_name }
        }) || []
      if (s?.sub_services) {
        subServices = [...subServices, ...newSs]
      }
    })
  }
  return subServices
}
interface IProps {
  onChange?: (
    subServices: Array<ISubService>,
    value: ISubServicesSelected
  ) => void
  onRemove?: (id: number, item?: ISubService) => void
  onAdd?: (id: number, item?: ISubService) => void
  value?: Array<ISubService>
  defaultValue?: Array<ISubService>
  preventSelect?: boolean
  services?: Array<IGroupService>
  totalAmount?: string
  bookingId?: number
  title?: boolean
  majorId?: number
}

const ServiceSelection = (props: IProps) => {
  const {
    onChange,
    onRemove,
    onAdd,
    value,
    preventSelect,
    totalAmount,
    title,
    bookingId,
    majorId
  } = props
  const { getNumberCommasFixed } = useFormatData()
  const { services } = useService()
  const { addSubServiceToBooking, removeSubServiceToBooking } = useExamService()
  const columns = useColumnService(onAction)
  // const historyColumns = useColumnHistoryService(onAction)
  const [menus, setMenus] = useState<Array<MenuItem>>([])
  const menuSelected: any = useRef(null)
  const groupServices: any = useRef<Array<IGroupService>>(null)
  const [optionsSub, setOptionsSub] = useState([])
  const keyDownEnterRef = useRef<any>(null)
  useEffect(() => {
    if (services) {
      groupServices.current = services
      const menus = buildMenuItems()
      setMenus(menus)
    }
  }, [value, services, majorId])

  useEffect(() => {
    if (menus?.length > 0) {
      let subs: any = []
      menus?.forEach((menu: any) => {
        const childrenSub = menu?.children?.map((child: any) => ({
          label: child.label,
          value: child.label,
          id: child.key,
          groupId: menu.key
        }))
        subs = [...subs, ...childrenSub]
      })
      setOptionsSub(subs)
    }
  }, [menus])

  useEffect(() => {}, [optionsSub])

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    children?: MenuItem[],
    type?: 'group'
  ): MenuItem {
    return {
      key,
      children,
      label,
      type
    } as MenuItem
  }

  const handleRemoveBooking = (item: any) => {
    const newSubServices: any = value?.filter((sub) => sub?.id !== item.id)
    const newMenus = buildMenuItems()
    setMenus(newMenus)
    if (onRemove) onRemove(item?.id, item)
    if (onChange) {
      const subServiceIds = newSubServices?.map((item: any) => item?.id)
      onChange(newSubServices, {
        price: getTotalAmount(newSubServices),
        subServiceIds: subServiceIds
      })
    }
  }

  function onAction(_: any, item: any) {
    if (preventSelect) return
    if (!bookingId) {
      handleRemoveBooking(item)
      return
    }
    removeSubServiceToBooking({
      booking_id: bookingId || 0,
      sub_service_ids: [Number(item?.id)]
    }).then((res) => {
      if (res?._successfully) {
        handleRemoveBooking(item)
      }
    })
  }

  const filteredServices = (groupServices.current || []).filter(
    (item: any) => item.major_id === majorId && item.sub_services?.length > 0
  )
  const buildMenuItems = () => {
    if (groupServices.current && majorId) {
      const servicesCompact = filteredServices.map((sv: any) => {
        return getItem(
          sv.name,
          sv.id,
          sv?.sub_services
            ?.filter((item: any) => {
              const isSelected = checkIsServiceSelected(item?.id)
              return item?.status === EStatus.Active && !isSelected
            })
            ?.map((subSv: any) => {
              return getItem(subSv.name, subSv.id)
            })
        )
      })
      return servicesCompact
    } else if (groupServices.current) {
      const servicesCompact = groupServices.current
        .filter((item: any) => (item as any).sub_services?.length > 0)
        ?.map((sv: any) => {
          return getItem(
            sv.name,
            sv.id,
            sv?.sub_services
              ?.filter((item: any) => {
                const isSelected = checkIsServiceSelected(item?.id)
                return item?.status === EStatus.Active && !isSelected
              })
              ?.map((subSv: any) => {
                return getItem(subSv.name, subSv.id)
              })
          )
        })
      return servicesCompact
    }
  }

  const checkIsServiceSelected = (id?: number) => {
    return value?.some((subService) => subService?.id === id)
  }

  const handleOnSelect = (menu: any) => {
    menuSelected.current = menu
  }

  const handleOnDoubleClick = () => {
    if (preventSelect) return
    const [subServiceId] = menuSelected?.current?.keyPath
    if (!bookingId) {
      handleAddBooking()
      return
    }
    addSubServiceToBooking({
      booking_id: bookingId || 0,
      sub_service_ids: [Number(subServiceId)]
    }).then((res) => {
      if (res?._successfully) {
        handleAddBooking()
      }
    })
  }

  const handleAddBooking = () => {
    const [subServiceId, groupServiceId] = menuSelected?.current?.keyPath
    const groupServiceSelected: any = groupServices.current.find(
      (m: any) => m?.id === Number(groupServiceId)
    )
    const subServiceSelected = groupServiceSelected?.sub_services?.find(
      (g: any) => g?.id === Number(subServiceId)
    )
    let newSubService: any = [subServiceSelected]
    if (value) {
      newSubService = [...value, ...newSubService]
    }
    const newMenus = buildMenuItems()
    setMenus(newMenus)
    menuSelected.current = null
    const subServiceIds = newSubService?.map((item: any) => item?.id)
    if (onChange)
      onChange(newSubService, {
        price: getTotalAmount(newSubService),
        subServiceIds: subServiceIds
      })
    if (onAdd) {
      onAdd(subServiceSelected?.id, subServiceSelected)
    }
  }

  const getTotalAmount = (services?: Array<ISubService>) => {
    return services?.reduce(
      (accumulator, currentValue) => accumulator + Number(currentValue?.price),
      0
    )
  }

  const total = useMemo(() => {
    return getTotalAmount(value)
  }, [value])

  const handleOnSelectSubService = (_: any, op: any) => {
    if (keyDownEnterRef.current) {
      keyDownEnterRef.current = false
      return
    }
    menuSelected.current = {
      key: op.id,
      keyPath: [op.id, op.groupId]
    }
    handleOnDoubleClick()
  }

  return (
    <StyleContainerTab>
      {!preventSelect && (
        <StyleLeftContent>
          <StyleSelect
            showSearch
            defaultActiveFirstOption={false}
            suffixIcon={<SearchOutlined />}
            options={optionsSub}
            placeholder={t('find-service')}
            value={null}
            notFoundContent={
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t('no-data')}
              />
            }
            onInputKeyDown={(e) => {
              // if (e.key === 'Enter') {
              //   keyDownEnterRef.current = true
              // }
            }}
            onSelect={handleOnSelectSubService}
          />
          <Divider />
          <Menu
            mode="inline"
            style={{ width: 256 }}
            items={menus}
            onClick={handleOnSelect}
            onDoubleClick={handleOnDoubleClick}
          />
        </StyleLeftContent>
      )}
      <StyleRightContent $hasBoxShadow={preventSelect}>
        <StyleHeadingWithButton>
          {title ? (
            <StyleCardTitle2>
              {t('indication-service')}
              <StyledAsterisk>*</StyledAsterisk>
            </StyleCardTitle2>
          ) : (
            <StyleCardTitle2>{t('indication-service')}</StyleCardTitle2>
          )}
          {/* <Button type="primary" icon={<SaveOutlined />}>
            {t('save')}
          </Button> */}
        </StyleHeadingWithButton>
        {/* <span>{t('diagnostic')}</span>
        <Input className="m-4" placeholder="Mô tả" /> */}
        <StyleBodyContent>
          <StyledTable
            $preventSelect={preventSelect}
            sticky
            columns={columns as any}
            dataSource={value}
            pagination={false}
            rowKey="id"
          />
          <StyleFooterContent>
            <StyleTotal>{`${t('total-services')}: ${
              value?.length
            }`}</StyleTotal>
            <StyleInforService>
              {`${t('total-amount')}: ${
                getNumberCommasFixed(Number(totalAmount || total) * 1000) || 0
              }`}
              <StyledSpanCurrency>{t('vnd')}</StyledSpanCurrency>
            </StyleInforService>
          </StyleFooterContent>
        </StyleBodyContent>

        {/* <StyleCardTitle>Lịch sử chỉ định</StyleCardTitle>
        <StyleBodyContent>
          <StyledTable
            $preventSelect={preventSelect}
            sticky
            columns={historyColumns as any}
            dataSource={value}
            pagination={false}
            rowKey="id"
          />
        </StyleBodyContent> */}
      </StyleRightContent>
    </StyleContainerTab>
  )
}

export default ServiceSelection
